import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

/** Layered perspective stage with reduced-motion and offscreen suspension. */
export function JusticeScene() {
  const stage = useRef<HTMLDivElement>(null);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    const node = stage.current;
    if (!node) return;
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;
    const reset = () => {
      cancelAnimationFrame(frame);
      node.style.setProperty("--rx", "0deg");
      node.style.setProperty("--ry", "0deg");
    };
    const move = (event: PointerEvent) => {
      if (paused || preference.matches || event.pointerType !== "mouse") return;
      const rect = node.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        node.style.setProperty("--rx", `${-y * 4}deg`);
        node.style.setProperty("--ry", `${x * 6}deg`);
      });
    };
    const observer = new IntersectionObserver(([entry]) => {
      node.classList.toggle("scene-outside", !entry.isIntersecting);
    });
    observer.observe(node);
    node.addEventListener("pointermove", move);
    node.addEventListener("pointerleave", reset);
    preference.addEventListener("change", reset);
    reset();
    return () => {
      reset();
      observer.disconnect();
      node.removeEventListener("pointermove", move);
      node.removeEventListener("pointerleave", reset);
      preference.removeEventListener("change", reset);
    };
  }, [paused]);
  return (
    <div
      ref={stage}
      className={`justice-scene${paused ? " scene-paused" : ""}`}
    >
      <div className="justice-stage" aria-hidden="true">
        <div className="justice-orbit orbit-one" />
        <div className="justice-orbit orbit-two" />
        <img
          className="justice-sculpture"
          src="/lady-justice-hero.webp"
          alt=""
          width="1024"
          height="1536"
          fetchPriority="high"
        />
        <div className="justice-front-rule" />
      </div>
      <div className="justice-caption">
        <span>CLARITY. BALANCE. PREPARATION.</span>
        <span>COURT CO-PILOT / 01</span>
      </div>
      <button
        type="button"
        className="motion-toggle"
        onClick={() => setPaused(!paused)}
        aria-pressed={paused}
      >
        {paused ? <Play size={12} /> : <Pause size={12} />}{" "}
        {paused ? "Resume motion" : "Pause motion"}
      </button>
    </div>
  );
}
